/**
 * @package   ScandiPWA\GtmGraphQl
 * @author    Abdelrahman Hady <abdelrahman.hady@scandiweb.com>
 * @copyright Copyright (c) 2023 Scandiweb, Inc (https://scandiweb.com)
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 */

import { CONTENTS_PRODUCTS } from 'Component/ProductCarousel/ProductCarousel.container';
import BrowserDatabase from 'Util/BrowserDatabase';

import Event, { EVENT_GTM_VIEW_PROMOTION_GA4 } from '../../../util/Event';
import ProductHelper from '../GA4_utils';
// eslint-disable-next-line import/no-cycle
import { NOT_APPLICABLE } from '../GA4_utils/Product';
import BaseEventEvent from './BaseEvent.event';

export const CHECKOUT_EVENT_DELAY = 1100;

/**
 * @namespace Gtm/Component/GoogleTagManager/GA4_events/ViewPromotion/Event */
export class ViewPromotionEvent extends BaseEventEvent {
    /**
     * Event fire delay
     *
     * @type {number}
     */
    eventHandleDelay = CHECKOUT_EVENT_DELAY;

    /**
     * Bind
     */
    bindEvent() {
        Event.observer(EVENT_GTM_VIEW_PROMOTION_GA4, (data) => {
            this.handle(data);
        });
    }

    /**
     * Handle
     */
    handler(data) {
        const {
            contentId, contentName, contentType, position, elemId
        } = data;
        const contentsProducts = BrowserDatabase.getItem(CONTENTS_PRODUCTS);
        const products = contentsProducts && contentsProducts[elemId] ? contentsProducts[elemId] : [];
        const productsData = products.map((product) => ({
            ...ProductHelper.getProductData(product),
            quantity: product.salable_qty || NOT_APPLICABLE,
            item_variant: NOT_APPLICABLE,
            ...this.getItemListData(product)
        }));
        const items = productsData.length ? { items: productsData } : {};

        this.pushEventData({
            currency: this.getCurrencyCode(),
            value: '',
            promotion_id: contentId,
            promotion_name: contentName,
            creative_name: contentType,
            creative_slot: position,
            location_id: '',
            ...items
        });
    }
}

export default ViewPromotionEvent;
